import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Form, Row, Col } from "react-bootstrap";
import "./OrderSampleDetails.scss"
import messages from "../../assets/i18n";
import ButtonStandard from "../../components/ButtonStandard/ButtonStandard";
import { HeaderActions, FooterActions, ToastMessage } from '../../components'

function SubContractorDetails(props) {

	const dispatch = useDispatch();

	const lang = useSelector(state => state.language.name);
    
    const selectedOrderSample = useSelector(state => state.orderSample.selectedOrderSample);
    const isLoading             = useSelector(state => state.orderSample.isLoading);
    const fetchedOrderSample  = useSelector(state => state.orderSample.fetchedOrderSampleDetails);
    const getOrderSample      = useSelector(state => state.orderSample.getOrderSample);
    	    
	const pageMessages = messages[lang].orderSampleDetailsPage

    const orderSampleToast = useSelector(state => state.orderSample.orderSampleToast);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-success');    	
    const [validated, setValidated]       = useState(false);

    const statusOptions = [
        { id: 1, message: 'Em Aprovação' },
        { id: 2, message: 'Aprovado' },
        { id: 3, message: 'Reprovado' },
    ];
    
    const [formFields, setFormFields] = useState({
        id: undefined,
        codigoFornecedor: '',
        nomeFornecedor: '',
        pedido: '',
        pedidoAmostra: '',
        descricao: '',
        status: statusOptions[0].id,
        motivo: ''
    });  
        
	const pageBack = () => {
		props.history.push(`/order-sample-list`);
    };

    const [isEdit, setIsEdit] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;

        event.preventDefault();
        event.stopPropagation();

        if (form.checkValidity()) {
            dispatch({
                type: 'SAVE_ORDER_SAMPLE',
                payload: formFields
            })
        }
    
        setValidated(true);
    };

    useEffect(() => {	
        setShowToast(orderSampleToast.showToast)
        setMessageError(orderSampleToast.message)
        setMessageType(orderSampleToast.messageType)
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderSampleToast]);
   
	useEffect(() => {
        if (selectedOrderSample.id) {
            setIsEdit(true)

            dispatch({
                type: 'UNSET_SELECTED_ORDER_SAMPLE',
                payload: {
                    id: null,
                    data: selectedOrderSample.data
                }
            })

            dispatch({
                type: 'GET_ORDER_SAMPLE_DETAILS',
                payload: {
                    orderSampleId: selectedOrderSample.data.id
                }
            })
        } else {
            setIsEdit(false)
         
            dispatch({
                type: 'UNSET_SELECTED_ORDER_SAMPLE',
                payload: {
                    id: null,
                    data: {}
                }
            })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {	
        if (getOrderSample) {
            setIsEdit(true)

            dispatch({
                type: 'GET_ORDER_SAMPLE_DETAILS',
                payload: {
                    orderSampleId: getOrderSample
                }
            })

            dispatch({ type: 'SET_GET_ORDER_SAMPLE', payload: null });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getOrderSample]);

    useEffect(() => {
        if (isEdit) {
            setFormFields({
                id: fetchedOrderSample.id,
                codigoFornecedor: fetchedOrderSample.codigoFornecedor,
                nomeFornecedor: fetchedOrderSample.nomeFornecedor,
                pedido: fetchedOrderSample.pedido,
                pedidoAmostra: fetchedOrderSample.pedidoAmostra,
                descricao: fetchedOrderSample.descricao,
                status: fetchedOrderSample.status.id,
                motivo: fetchedOrderSample.motivo
            })
        } else {
            setFormFields({
                id: undefined,
                codigoFornecedor: '',
                nomeFornecedor: '',
                pedido: '',
                pedidoAmostra: '',
                descricao: '',
                status: statusOptions[0].id,
                motivo: ''
            })
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchedOrderSample]);

    const saveButton = disabled => () =>
        <ButtonStandard
            id="norm_save_button"
            type="submit"
            text={messages[lang].save}
            textClass="text-2"
            isLoading={isLoading}
            disabled={disabled}
            className="btn btn-primary btn-save btn-light"
        />;

	return (
		<div className="order-sample-details-page">
            <ToastMessage 
                show={showToast} 
                setShow={setShowToast}
                message={messageError} 
                toastClass={messageType} />
			<HeaderActions
				pageBack={pageBack}
				titlePage={isEdit ? pageMessages.titleEdit : pageMessages.titleNew}
			/>
            <div>
                <Container className="pt-3 justify-content-start">
                    <div>
                    <Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.descricao}</Form.Label>
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.descricao}
                                    maxLength={255}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, descricao: event.target.value },
                                    )}
                                    />
                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.fornecedor}</Form.Label>
                                <Form.Control
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.codigoFornecedor ? formFields.codigoFornecedor + ' - ' + formFields.nomeFornecedor : ''}
                                    disabled={true}
                                    />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.pedidoAmostra}</Form.Label>
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.pedidoAmostra || ''}
                                    disabled={isEdit || isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, pedidoAmostra: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.pedidoOriginal}</Form.Label>
                                <Form.Control
                                    required
                                    className="text-2 border-radius-full"
                                    type="text"
                                    value={formFields.pedido || ''}
                                    disabled={isEdit || isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, pedido: event.target.value },
                                    )}
                                    />

                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} xs={6} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.status}</Form.Label>
                                <div key={formFields.status}>
                                    <Form.Control
                                        required
                                        as="select"
                                        className="text-2 border-radius-full"
                                        type="text"
                                        defaultValue={formFields.status}
                                        disabled={isLoading}
                                        onChange={event => setFormFields(
                                            { ...formFields, status: event.target.value },
                                        )}
                                    >
                                        {
                                            statusOptions.map(value => (
                                                <option key={value.message} value={value.id}>{value.message}</option>
                                            ))
                                        } 
                                    </Form.Control>
                                </div>
                                <Form.Control.Feedback type="invalid">
                                    {messages[lang].requiredField}
                                </Form.Control.Feedback>

                            </Form.Group>	
                        </Row>
                        <Row>
                            <Form.Group as={Col} xs={12} className="mt-1">
                                <Form.Label className="text-2">{pageMessages.motivo}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    className="text-2 border-radius-full"
                                    type="text"
                                    maxLength={255}
                                    rows={2}
                                    value={formFields.motivo || ''}
                                    disabled={isLoading}
                                    onChange={event => setFormFields(
                                        { ...formFields, motivo: event.target.value },
                                    )}
                                    />
                            </Form.Group>
                        </Row>
                        <FooterActions
                            ButtonGroupRight={saveButton(isLoading)}/>
                    </Form>
                    </div>
                </Container>
            </div>               
		</div>
	)
}

export default withRouter(SubContractorDetails);